import { Request } from 'lib/types';

const day = 86400000;
const dateOffsets = [day * 1, day * 2, day * 3, day * 4];
const dateOptions = {month: '2-digit', day: '2-digit', year: 'numeric'};
const date = (offset: number) => (new Date(Date.now() - dateOffsets[offset])).toLocaleString('en-US', dateOptions);

const requestsList: Request[] = [
	{ id: 62428, priority: 'High', name: 'Farrah Nichols', date: date(0), 
		type: 'Privacy Delete', requestor: 'Andy Wilson', status: 'New'},
	{ id: 27253, priority: 'High', name: 'Samantha Smith-Jones', date: date(0), 
		note: 'Sam\'s Reward Level is not correct due to her two profiles.',
		type: 'Profile Merge', requestor: 'Andy Wilson', status: 'New'},
	{ id: 19073, priority: 'Medium', name: 'Chad Rogers', date: date(3), 
		type: 'Match Candidate', requestor: 'System', status: 'New'},
	{ id: 87764, priority: 'Low', name: 'Barry Moore', date: date(1), 
		type: 'Match Candidate', requestor: 'System', status: 'New'},
	{ id: 90637, priority: 'Low', name: 'Jane Craigs', date: date(2), 
		type: 'Match Candidate', requestor: 'System', status: 'New'},
];

export default requestsList;


// WEBPACK FOOTER //
// ./src/data/data-stewardship.ts